import React from "react";
import Synonyms from "./Synonyms";
import "./Definition.css";

export default function Definition(props) {
  function childToParent(word) {
    let synonym = word;
    props.definitionToApp(synonym);
  }

  return (
    <div className="Definition">
      {props.meanings.map(function (meaning, index) {
        return (
          <div key={index}>
            <section className="my-2 mx-3 pb-3 shadow">
              <div className="row partOfSpeech pt-3 mb-4 ms-3">
                {meaning.partOfSpeech}
              </div>

              <ul>
                {meaning.definitions.map(function (def, index) {
                  return (
                    <li className="row definitions ms-3 mb-2" key={index}>
                      {def.definition}
                      <div className="example ps-0">
                        <em>{def.example}</em>
                      </div>
                      <Synonyms
                        synonyms={def.synonyms}
                        childToParent={childToParent}
                      />
                    </li>
                  );
                })}
              </ul>
            </section>
          </div>
        );
      })}
    </div>
  );
}
